module.exports = __webpack_public_path__ + "assets/img/261a2e9043ee4f7488bd2200c731c98f.png";